<template>
  <div class="display-flex h100vh align-center" v-if="!isUserAuthenticated && !loading">
    <div class="col-1-container h100vh none show-dk"></div>
    <div class="col-2-container h100p display-flex flex-column justify-start w100p">
      <div class="display-flex flex-column mt2">
        <div class="display-flex f1-7">
          <router-link to="/">
            <span class="logo mr1 ma0">
              <img alt="logo" src="/assets/tbhLogo.png" />
            </span>
          </router-link>
          <div>
            <span class="f1-9 ma0">Techolution </span>
            <span class="sub-italic f1 text-left ma0 block"><em>Techolution</em></span>
          </div>
        </div>
      </div>
      <div class="login-box-container display-flex flex-column justify-center align-center">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'tbh-login',
  computed: {
    ...mapGetters(['loading']),
    ...mapGetters('common/user', ['isUserAuthenticated'])
  },
  mounted() {
    this.clearUser()
  },
  methods: {
    ...mapActions('common/user', ['clearUser'])
  }
}
</script>

<style scoped>
  .col-1-container {
    flex: 0 0 50%;
    background-image: linear-gradient(to right , rgba(87, 99, 179, 0.192)),
    url("/assets/Device.png");
    background-size: cover;
    background-position: top;
  }

  .login-box-container {
    flex: .93;
  }

  .col-2-container {
    margin: 0 6% 0 6%;
  }

  .logo {
    width: 4.6rem;
    height: 4.6rem;
  }

  em {
    color: #8E8E8E;
  }
</style>
